import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { colors, fonts } from "./theme/tokens";

const theme = createTheme({
  palette: {
    primary: { main: colors.brandNavy },
    secondary: { main: colors.amber },
    text: { primary: colors.brandNavy, secondary: colors.mutedText },
    background: { default: colors.canvas },
  },
  typography: {
    fontFamily: fonts.body,
    h1: { fontFamily: fonts.display },
    h2: { fontFamily: fonts.display },
    h3: { fontFamily: fonts.display },
    h4: { fontFamily: fonts.display },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
